import { type SvgProps, SvgWrapper } from '../utils';

export function DoubleChevronLeftIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M10.4697 6.46967C10.7626 6.17678 11.2374 6.17678 11.5303 6.46967C11.8232 6.76256 11.8232 7.23732 11.5303 7.53022L7.06054 11.9999L11.5303 16.4697C11.8232 16.7626 11.8232 17.2373 11.5303 17.5302C11.2374 17.8231 10.7626 17.8231 10.4697 17.5302L5.46972 12.5302C5.17683 12.2373 5.17683 11.7626 5.46972 11.4697L10.4697 6.46967Z" />
      <path d="M17.4697 6.46967C17.7626 6.17678 18.2374 6.17678 18.5303 6.46967C18.8232 6.76256 18.8232 7.23732 18.5303 7.53022L14.0605 11.9999L18.5303 16.4697C18.8232 16.7626 18.8232 17.2373 18.5303 17.5302C18.2374 17.8231 17.7626 17.8231 17.4697 17.5302L12.4697 12.5302C12.1768 12.2373 12.1768 11.7626 12.4697 11.4697L17.4697 6.46967Z" />
    </SvgWrapper>
  );
}
